import Gading1 from '../Gading/Gading (1).webp'
import Gading2 from '../Gading/Gading (2).webp'
import Gading3 from '../Gading/Gading (3).webp'
import Gading4 from '../Gading/Gading (4).webp'

const Gadingimages =[
Gading1,Gading2,Gading3,Gading4
]

export default Gadingimages;